export default __webpack_public_path__ + "static/media/logo.c4f913b8.png";